// extracted by mini-css-extract-plugin
export default {"wrapper":"NoPayments_wrapper__0FOrK","text":"NoPayments_text__NdZ0F"};